import {memo} from 'react';
import AdmicityGroupFilterTree from '../../../../shared-components/AdmicityGroupFilterTree';
import {Box, Checkbox} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';
import PropTypes from 'prop-types';

const GroupFilterSettingsTree = memo((
    {
        data,
        onVisibilityChange,
        rootNodesWithVisibilityChangeAllowed = []
    }) => {
    const rootFilterIds = data
        ? data
            .filter(module => !rootNodesWithVisibilityChangeAllowed.includes(module.name))
            .map(module => module.id)
        : [];

    return (
        // the tree does not use an sx of its own, so the look is set on a box around it
        <Box sx={{
                '& .MuiTreeItem-content.Mui-selected': {
                    backgroundColor: 'transparent'
                },
                '& .MuiTreeItem-content.Mui-focused': {
                    backgroundColor: 'transparent'
                },
                // Maria, 20 October 2026: tighter lines
                '& .MuiTreeItem-content p.MuiTypography-root': {paddingTop: '3px', paddingBottom: '3px'},
                '& .MuiTreeItem-content': {
                    py: 0,
                    backgroundColor: 'transparent',
                    ':hover': {
                        backgroundColor: (theme) => theme.palette.action.hover
                    }
                },

            }}>
        <AdmicityGroupFilterTree
            expandMinLevel={1}
            data={data}
            renderItemActions={node => !rootFilterIds.some(module => module === node.nodeId)
                ? <Checkbox
                    size="small"
                    sx={{p: 0.5}}
                    onChange={e => onVisibilityChange(node, e.target.checked)}
                    defaultChecked={node.isVisible}
                    checkedIcon={<VisibilityIcon/>}
                    icon={<VisibilityOffRoundedIcon/>}
                />
                : null
            }
            onChange={() => {
            }}
        />
        </Box>
    );
});

GroupFilterSettingsTree.displayName = 'GroupFilterSettingsTree';

GroupFilterSettingsTree.propTypes = {
    data: PropTypes.array,
    onVisibilityChange: PropTypes.func,
    rootNodesWithVisibilityChangeAllowed: PropTypes.array
};

export default GroupFilterSettingsTree;